// Cookbook Studio API client
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeaders = () => {
  const token = localStorage.getItem("shweebum_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const cookbookApi = {
  create: async (body) => (await axios.post(`${API}/cookbooks`, body, { headers: authHeaders() })).data,
  get: async (pid) => (await axios.get(`${API}/cookbooks/${pid}`, { headers: authHeaders() })).data,
  update: async (pid, body) => (await axios.patch(`${API}/cookbooks/${pid}`, body, { headers: authHeaders() })).data,

  addPart: async (pid, body) => (await axios.post(`${API}/cookbooks/${pid}/parts`, body, { headers: authHeaders() })).data,
  removePart: async (pid, partId) => (await axios.delete(`${API}/cookbooks/${pid}/parts/${partId}`, { headers: authHeaders() })).data,
  addSection: async (pid, partId, body) => (await axios.post(`${API}/cookbooks/${pid}/parts/${partId}/sections`, body, { headers: authHeaders() })).data,
  removeSection: async (pid, partId, sectionId) => (await axios.delete(`${API}/cookbooks/${pid}/parts/${partId}/sections/${sectionId}`, { headers: authHeaders() })).data,

  listRecipes: async (pid, filters = {}) => {
    const p = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "") p.append(k, v); });
    return (await axios.get(`${API}/cookbooks/${pid}/recipes?${p.toString()}`, { headers: authHeaders() })).data;
  },
  createRecipe: async (pid, body) => (await axios.post(`${API}/cookbooks/${pid}/recipes`, body, { headers: authHeaders() })).data,
  getRecipe: async (pid, rid) => (await axios.get(`${API}/cookbooks/${pid}/recipes/${rid}`, { headers: authHeaders() })).data,
  updateRecipe: async (pid, rid, body) => (await axios.patch(`${API}/cookbooks/${pid}/recipes/${rid}`, body, { headers: authHeaders() })).data,
  deleteRecipe: async (pid, rid) => (await axios.delete(`${API}/cookbooks/${pid}/recipes/${rid}`, { headers: authHeaders() })).data,
  promoteFromVault: async (pid, vaultItemId, partId, sectionId) => {
    const p = new URLSearchParams();
    if (partId) p.append("part_id", partId);
    if (sectionId) p.append("section_id", sectionId);
    return (await axios.post(`${API}/cookbooks/${pid}/recipes/from-vault/${vaultItemId}?${p.toString()}`, {}, { headers: authHeaders() })).data;
  },
};

export const contributorApi = {
  roles: async () => (await axios.get(`${API}/contributors/roles`)).data,
  list: async (pid) => (await axios.get(`${API}/contributors/projects/${pid}`, { headers: authHeaders() })).data,
  invite: async (pid, body) => (await axios.post(`${API}/contributors/projects/${pid}/invite`, { ...body, project_id: pid }, { headers: authHeaders() })).data,
  changeRole: async (pid, cid, role) => (await axios.patch(`${API}/contributors/projects/${pid}/${cid}`, { role }, { headers: authHeaders() })).data,
  revoke: async (pid, cid) => (await axios.delete(`${API}/contributors/projects/${pid}/${cid}`, { headers: authHeaders() })).data,
  myInvites: async () => (await axios.get(`${API}/contributors/me/invites`, { headers: authHeaders() })).data,
  acceptInvite: async (inviteId) => (await axios.post(`${API}/contributors/invites/${inviteId}/accept`, {}, { headers: authHeaders() })).data,
};
